<p-panel header="{{'panel_notes_note' | translate}} {{addNoteForm.get('title').value}}">
    <app-loader *ngIf="loader"></app-loader>
    <form *ngIf="!loader" [formGroup]="addNoteForm" (submit)="onSubmit()">
        <app-loader *ngIf="loading"></app-loader>
        <div class="p-grid">
            <div class="p-col-12 p-sm-12 p-md-8 p-lg-9 p-xl-9">
                <div *ngIf="!loading">
                    <div style="margin-top:20px;"></div>

                    <div class="ui-g">
                        <div class="ui-g-9 ui-sm-12 nopadding">
                            <span class="ui-float-label">
                                <input type="text" formControlName="title" pInputText style="width:100%">
                                <label for="float-input">{{'panel_notes_title' | translate}}</label>
                            </span>
                        </div>
                        <div class="ui-g-3 ui-sm-12 nopadding marginMobile">
                            <span class="ui-float-label">
                                <input [readOnly]="waitForCalculate" (keyup)="onChangePrice($event)" currencyMask formControlName="price" pInputText [options]="{ prefix: '', suffix: ' zł ', thousands: '.', decimal: ',' }" style="width: 100%;"/>
                                <label for="float-input">{{'panel_notes_price' | translate}}</label>
                            </span>
                        </div>
                    </div>


                    <div style="margin-top: 20px;"></div>

                    <span class="ui-float-label">
                        <textarea [rows]="5" [cols]="30" formControlName="description" pInputTextarea style="width: 100%;"></textarea>
                        <label for="float-input">{{'panel_notes_desc' | translate}}</label>
                    </span>
                    <div style="margin-top:20px;"></div>

                    <div class="ui-g ">
                        <div class="ui-g-4 ui-sm-12 nopadding">
                            <span class="ui-float-label">
                                <input type="text" formControlName="composer" pInputText style="width:100%">
                                <label for="float-input">{{'panel_notes_composer' | translate}}</label>
                            </span>
                        </div>
                        <div class="ui-g-4 ui-sm-12 nopadding smallMarginMobile">
                            <span class="ui-float-label">
                                <input type="text" formControlName="text_author" pInputText style="width:100%">
                                <label for="float-input">{{'panel_notes_text_author' | translate}}</label>
                            </span>
                        </div>
                        <div class="ui-g-4 ui-sm-12 nopadding smallMarginMobile">
                            <span class="ui-float-label">
                                <input type="text" formControlName="music_author" pInputText style="width:100%">
                                <label for="float-input">{{'panel_notes_music_author' | translate}}</label>
                            </span>
                        </div>
                    </div>


                    <div style="margin-top: 20px;"></div>

                    <div class="ui-g ">
                        <div class="ui-g-4 ui-sm-12 nopadding">
                            {{'panel_notes_file_notes' | translate}}
                            <p-fileUpload chooseLabel="{{'panel_notes_btn_add' | translate}}" name="note"
                            [disabled]="noteFiles.length > 0"
                            url="{{_url}}/uploadNote" (onUpload)="onUploadNote($event)" [auto]="true">

                                <ng-template pTemplate="content">
                                    <ul *ngIf="noteFiles.length" style="list-style: none;padding: 0;margin: 0;">
                                        <li *ngFor="let file of noteFiles">
                                            <div style="display: flex;align-items: center;">
                                                <div class="upload_filename">{{file.name}}</div>
                                                <span (click)="onRemoveUploadedNote()" style="line-height: 0;margin-right: 7px;cursor: pointer;">  <i class="pi pi-times" style="font-size: 1rem"></i> </span>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-template>

                            </p-fileUpload>
                        </div>
                        <div class="ui-g-4 ui-sm-12 nopadding smallMarginMobile">
                            {{'panel_panel_notes_file_preview' | translate}}
                            <p-fileUpload chooseLabel="{{'panel_notes_btn_add' | translate}}" name="preview"
                            [disabled]="previewFiles.length > 0"
                            url="{{_url}}/uploadPreview" (onUpload)="onUploadPreview($event)" accept="application/pdf" [auto]="true">

                                <ng-template pTemplate="content">
                                    <ul *ngIf="previewFiles.length" style="list-style: none;padding: 0;margin: 0;">
                                        <li *ngFor="let file of previewFiles">
                                            <div style="display: flex;align-items: center;">
                                                <div class="upload_filename">{{file.name}}</div>
                                                <span (click)="onRemoveUploadedPreview()" style="line-height: 0;margin-right: 7px;cursor: pointer;">  <i class="pi pi-times" style="font-size: 1rem"></i> </span>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-template>

                            </p-fileUpload>
                        </div>
                        <div class="ui-g-4 ui-sm-12 nopadding smallMarginMobile">
                            {{'panel_notes_file_sound' | translate}}
                            <p-fileUpload chooseLabel="{{'panel_notes_btn_change' | translate}}" name="sound" accept="audio/*"
                                url="{{_url}}/uploadSound" (onUpload)="onUploadSound($event)" [auto]="true">
                                <ng-template pTemplate="content">
                                    <app-audio-player *ngIf="soundFiles.length > 0" [autoPlay]="false" [src]="sample_audioWithUrl"></app-audio-player>
                                </ng-template>
                            </p-fileUpload>


                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12 p-sm-12 p-md-4 p-lg-3 p-xl-3">
                {{'panel_notes_profit' | translate}}: <span style="font-weight: bold;">{{profit | currencyReduce: true | currency: "PLN"}}</span>
                <div style="margin-bottom:10px;margin-top:13px;display: block;" [innerHTML]="'panel_notes_categories' | translate"></div>
                <app-category (onSelectCategory)="onSelectCategory($event)" [categories]="categoryEdit"></app-category>

                <div style="margin-bottom:10px;display: block;">{{'search_page_level' | translate}}</div>
                <app-note-level [levelFilter]="noteLevel" (action)="handleLevelChange($event)"></app-note-level>

                <div style="margin-top:10px;">
                  <div style="margin-bottom: 13px;">{{'note_is_folk' | translate}}</div>
                  <p-inputSwitch formControlName="is_folk"></p-inputSwitch>
                </div>

                <div style="margin-top:10px;">
                    <div style="margin-bottom: 13px;">{{'note_is_active' | translate}}</div>
                    <p-inputSwitch formControlName="is_active"></p-inputSwitch>
                </div>

                <div *ngIf="note.id" style="margin-top:10px;">
                    <button (click)="onDeleteNote(note)" pButton type="button" [label]="'delete_button' | translate" class="ui-button-secondary"></button>
                </div>

            </div>

            <div style="margin: 20px 0 10px 10px;">
              <button [disabled]="saving" pButton type="submit" label="{{'panel_notes_btn_save' | translate}}"
                  style="right: 0;position: relative;" class="ui-button-raised ui-button-success">
                  <app-loader *ngIf="saving" [center]="true" [size]="30"></app-loader>
              </button>
          </div>
        </div>




    </form>
</p-panel>
